import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/service/page";
import Booking from "../pages/booking/page";
import Login from "../pages/login/page";
import Profile from "../pages/profile/page";
import AuthCallback from "../pages/auth/callback/page";
import ResetPassword from "../pages/auth/reset-password/page";
import AdminBookings from "../pages/admin/bookings/page";
import AdminServices from "../pages/admin/services/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/service/:slug",
    element: <ServiceDetail />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/admin/bookings",
    element: <AdminBookings />,
  },
  {
    path: "/admin/services",
    element: <AdminServices />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;